// Heuristics for turning a flat list of PDF pages into labelled chapters. A page whose first line
// looks like a heading ("Chapter 3", "Part II", an ALL-CAPS title) starts a new chapter; otherwise
// the page's text is appended to the chapter in progress.

const HEADING_PATTERNS: readonly RegExp[] = [
  /^chapter\s+(\d+|one|two|three|four|five|six|seven|eight|nine|ten|[ivxlcdm]+)\b/i,
  /^part\s+(\d+|one|two|three|four|five|[ivxlcdm]+)\b/i,
  /^book\s+(\d+|one|two|three|four|five|[ivxlcdm]+)\b/i,
  /^section\s+(\d+|one|two|three|four|five|[ivxlcdm]+)\b/i,
  /^([IVXLCDM]+)\.\s/,
  /^(\d+)\.\s+[A-Z]/,
];

const MAX_HEADING_LENGTH = 100;
const MAX_ALLCAPS_HEADING_LENGTH = 50;

/** Return the heading text if the first paragraph reads like a chapter title, else null. */
export function detectChapterHeading(firstParagraph: string | undefined): string | null {
  if (!firstParagraph) return null;

  for (const pattern of HEADING_PATTERNS) {
    if (pattern.test(firstParagraph) && firstParagraph.length < MAX_HEADING_LENGTH) {
      return firstParagraph;
    }
  }

  const isShortAllCaps =
    firstParagraph.length < MAX_ALLCAPS_HEADING_LENGTH &&
    firstParagraph === firstParagraph.toUpperCase() &&
    /[A-Z]/.test(firstParagraph);
  if (isShortAllCaps) return firstParagraph;

  return null;
}
